module.exports = __webpack_public_path__ + "img/earth.59467aeb.svg";